var _linearGradient, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChanges(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fHH1575ypYIq9ckEi_Imra",
    x1: 31,
    x2: 31,
    y1: 0.192,
    y2: 34.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#199ae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0782d8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fHH1575ypYIq9ckEi_Imra)",
    d: "M44.707,8.293l-8-8c-0.391-0.391-1.023-0.391-1.414,0l-8,8c-0.286,0.286-0.372,0.716-0.217,1.09C27.231,9.756,27.596,10,28,10h3v14H17v10h22c1.105,0,2-0.895,2-2V10h3c0.404,0,0.769-0.244,0.924-0.617C45.079,9.009,44.993,8.579,44.707,8.293z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3cf",
    d: "M31,24V14H9c-1.105,0-2,0.895-2,2v22H4c-0.404,0-0.769,0.244-0.924,0.617c-0.155,0.374-0.069,0.804,0.217,1.09l8,8c0.391,0.391,1.023,0.391,1.414,0l8-8c0.286-0.286,0.372-0.716,0.217-1.09C20.769,38.244,20.404,38,20,38h-3V24H31z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChanges);
export default __webpack_public_path__ + "static/media/changes.95de73e7.svg";
export { ForwardRef as ReactComponent };